export default {
  title: 'Steuerungsstatus:',
};
